import { PayloadAction } from '@reduxjs/toolkit';

import { SET_USER } from '@/types/store/actions';
import { User } from '@/types/store/reducers';

const initialState: User = {};

export function userReducer(state = initialState, action: PayloadAction<User>): User {
	switch (action.type) {
		case SET_USER:
			return { ...action.payload };
		default:
			return state;
	}
}
